import { stimulusApp } from './application.js'
import DashboardChartsController from './dashboard_charts_controller.js'
import ScaConsentCallbackController from './sca_consent_callback_controller.js'
import GtmEventController from './gtm_event_controller.js'
import SmartInvestAnnouncementController from './smart_invest_announcement_controller'
import FormCompletenessController from './form_completeness_controller.js'
import ProfileCompletionController from './profile_completion_controller.js'
import CheckboxFilterController from './checkbox_filter_controller.js'
import PasswordVisibilityController from './password_visibility_controller.js'
import CurrencyToggleController from './currency_toggle_controller.js'
import NavbarController from './navbar_controller.js'
import TaxLocationController from './tax_location_controller.js'
import PepToggleController from './pep_toggle_controller.js'
import PepDescriptionController from './pep_description_controller.js'
import StickySubscribeController from './sticky_subscribe_controller.js'
import CarouselController from './carousel_controller.js'
import PayinController from './payin_controller.js'
import SimulatorV2Controller from './simulator_v2_controller.js'

// Register controllers
stimulusApp.register('dashboard-charts', DashboardChartsController);
stimulusApp.register('sca-consent-callback', ScaConsentCallbackController);
stimulusApp.register('gtm-event', GtmEventController);
stimulusApp.register('smart-invest-announcement', SmartInvestAnnouncementController);
stimulusApp.register('form-completeness', FormCompletenessController);
stimulusApp.register('profile-completion', ProfileCompletionController);
stimulusApp.register('checkbox-filter', CheckboxFilterController);
stimulusApp.register('password-visibility', PasswordVisibilityController);
stimulusApp.register('currency-toggle', CurrencyToggleController);
stimulusApp.register('navbar', NavbarController);
stimulusApp.register('tax-location', TaxLocationController);
stimulusApp.register('pep-toggle', PepToggleController);
stimulusApp.register('pep-description', PepDescriptionController);
stimulusApp.register('sticky-subscribe', StickySubscribeController);
stimulusApp.register('carousel', CarouselController);
stimulusApp.register('payin', PayinController);
stimulusApp.register('simulator-v2', SimulatorV2Controller);
